import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';

import { MessagesService } from '../../../services/api.services';
import { FuturaLineaProformaFront } from '../../../models/api.models';

import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { SendClickEventEmitter } from '../send.click.event.emitter';

@Component({
  selector: 'app-issues-crear-proformables-escritorio',
  templateUrl: './issues-crear-proformables-escritorio.component.html',
  styleUrls: ['./issues-crear-proformables-escritorio.component.scss'],
})
export class IssuesCrearProformablesEscritorioComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;

  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();
  @Input() proformasToCreate: FuturaLineaProformaFront[];

  ColumnMode = ColumnMode;

  editing = {};
  editable = true; // TODO: cuando venga isEditable del back cambiarlo linesIds.isEditable
  crearProformableNextClick: SendClickEventEmitter = new SendClickEventEmitter();

  constructor(private messages: MessagesService,
              private modalCtrl: ModalController) { }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      this.proformasToCreate.forEach((proformaToCreate, index) => {
        if (proformaToCreate.issueFrontAsociada.b_requiere_presupuesto_aprobado === true) {
          proformaToCreate.manoObra = proformaToCreate.issueFrontAsociada.labor_cost;
          proformaToCreate.material = proformaToCreate.issueFrontAsociada.material_cost;
        }
      });
    });
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  siguiente() {
    const toSend: SendClickEventEmitter = new SendClickEventEmitter();
    toSend.clicked = true;
    toSend.tabla = 'crear-proformable-escritorio';
    toSend.proformasToCreate = this.proformasToCreate;
    this.nextClicked.emit(toSend);
  }

  atras() {
    const toSend: SendClickEventEmitter = new SendClickEventEmitter();
    toSend.clicked = true;
    toSend.tabla = 'crear-proformable-escritorio';
    toSend.proformasToCreate = this.proformasToCreate;
    this.backClicked.emit(toSend);
  }

  getHeaderClass({ row, column, value }): any {
    if (column.prop === 'issueFrontAsociada.manoObra' || column.prop === 'issueFrontAsociada.material') {
      return {
        'cell-right-position': true
      };
    }
  }

  getCellClass({ row, column, value }): any {
    if (row.issueFrontAsociada.b_requiere_presupuesto_aprobado === false && (column.prop === 'issueFrontAsociada.manoObra' || column.prop === 'issueFrontAsociada.material')) {
      return {
        'is-editable': true,
        'cell-right-position': true
      };
    }else if (row.issueFrontAsociada.b_requiere_presupuesto_aprobado === true && (column.prop === 'issueFrontAsociada.manoObra' || column.prop === 'issueFrontAsociada.material')) {
      return {
        'is-editable': false,
        'cell-right-position': true
      };
    }
  }

}
